import PageLoader from '@/app/common/components/PageLoader/PageLoader'
import { AppRoutePaths } from '@/routing/route_paths'
import { useNavigate } from 'react-router-dom'
import ProviderItems from '../../marketplace-live/providers/ProviderItems'
import { useMarketplacePreviewData } from '../hooks/useMarketplacePreviewData'
import { MarketplaceItem } from '@/apis/marketplace/marketplace.schema'

export default function MarketplacePreviewProviderDetailsPage() {
  const navigate = useNavigate()

  const {
    currentPage,
    perPage,
    setCurrentPage,
    setPerPage,
    handleFilterOnChange,
    itemSearch,
    setItemSearch,
    itemsQuery,
    storesQuery,
  } = useMarketplacePreviewData()

  // Create a wrapper function for setSelectedFilter that matches the expected signature
  const handleSetSelectedFilter = (filterValue: string) => {
    // Convert string filter to the format expected by handleFilterOnChange
    const filterId = filterValue === '' ? 0 : parseInt(filterValue)
    handleFilterOnChange({ id: filterId, name: '' })
  }

  function handleShopClick(item: MarketplaceItem) {
    navigate(
      AppRoutePaths.marketplace_preview.details.replace(
        ':itemId',
        item.id.toString()
      )
    )
  }

  const items = itemsQuery.data?.data ?? []

  return (
    <PageLoader query={storesQuery}>
      {(store) => {
        return (
          <div>
            <ProviderItems
              currentPage={currentPage}
              provider={store}
              perPage={perPage}
              totalRecords={itemsQuery.data?.total ?? 0}
              setCurrentPage={setCurrentPage}
              onItemClick={handleShopClick}
              setPerPage={setPerPage}
              search={itemSearch}
              setSearch={setItemSearch}
              setSelectedFilter={handleSetSelectedFilter}
              items={items}
            />
          </div>
        )
      }}
    </PageLoader>
  )
}
